export default "/assets/images/filter-air3.3e79a6d74984ae4d.jpg";